import classnames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';

import type { Props as HeaderProps } from './Header';
import { Header } from './Header';

type Props = HeaderProps & {
  noBorder?: boolean;
  children?: ReactNode;
};

const Root = styled(Vertical).attrs({ gap: 2 })`
  align-items: stretch;
  background-color: var(--c-nd-50);
  border-radius: var(--double-unit);
  width: 100%;
  padding: var(--double-unit);
  &.noBorder {
    border-top: none;
  }
`;

export const SettingsSection = ({
  title,
  description,
  noBorder,
  children,
  toggleButton,
}: Props) => {
  return (
    <Root className={classnames({ noBorder })}>
      <Header
        title={title}
        description={description}
        toggleButton={toggleButton}
      />
      {children}
    </Root>
  );
};
